import React from 'react';

const ExternalServicesContext = React.createContext({});

export default ExternalServicesContext;
